export default "__VITE_ASSET__Cc3cWEX___"